import clsx from "clsx";
import { HeaderNotificationsMenu, HeaderUserMenu } from "../../../partials";
import { useLayout } from "../../core";
import { useAuth } from "../../../../app/modules/auth";
import { HeaderPaymentMenu } from "../../../partials/layout/header-menus/HeaderPaymentMenu";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { RegisterProducerCenterModal } from "../../../../app/modules/producerCenter/components/RegisterProducerCenterModal";
import { useLocation } from "react-router-dom";
import { useFirstLogin } from "../../../../app/modules/auth/core/TourGuideContext";
import { VisitedChecker } from "../../../../app/modules/auth/core/VisitedChecker";
import { KTIcon } from "../../../helpers";
import { useQuery } from "@tanstack/react-query";
import { GetLackOfWalletDeviceRequestSMSSentCount } from "../../core/_Requests";
import { SoftwareDownload } from "../../../../app/modules/dashboard/SoftwareDownload";
import "../../../partials/layout/header-menus/HeaderNotificationsMenuCSS.css";
import { useSetUserProducerCenterSpecificationAndWallet } from "../../../../app/modules/producerCenter/components/useSetUserProducerCenterSpecificationAndWallet";

const itemClass = "ms-1 ms-md-4 ";
const userAvatarClass = "symbol-35px";
interface HeaderNotificationsMenuProps {
  requestSMSCount: number;
}
const Navbar = () => {
  const { setFirstLoginStatus, showDownloadLink, setShowDownloadLinkValue } = useFirstLogin();
  const { config } = useLayout();
  const location = useLocation();
  const { currentUser, producerStatus, userProducerCenter } = useAuth();
  const [displayRegisterProducerCenterModal, setDisplayRegisterProducerCenterModal] = useState(false);
  const [displayRegisterProducerCenterStep1, setDisplayRegisterProducerCenterStep1] = useState(false);
  const [requestSMSCount, setRequestSMSCount] = useState(0);
  const {UpdateProducerCenterWalletPrice} = useSetUserProducerCenterSpecificationAndWallet();

  const hideRegisterProducerCenterModal = () => {
    setDisplayRegisterProducerCenterModal(false);
  };

  useEffect(() => {
    if (producerStatus === "not_exists") {
      if (currentUser?.nationalCode == null || currentUser?.phoneNumber == null
      ) {
        setDisplayRegisterProducerCenterStep1(true);
      } else {
        setDisplayRegisterProducerCenterStep1(false);
      }
      setDisplayRegisterProducerCenterModal(true);
    } else {
      setDisplayRegisterProducerCenterModal(false);
    }
  }, [currentUser?.nationalCode, currentUser?.phoneNumber, producerStatus]);

  useEffect(() => {
    setFirstLoginStatus(true);
    if (window.location.pathname.endsWith('dashboard')) {
      document.body.setAttribute('data-kt-app-sidebar-minimize', 'off')
    }
    else {
      document.body.setAttribute('data-kt-app-sidebar-minimize', 'on')
    }
  }, [location.pathname]);

  const { data: GetLackOfWalletDeviceRequestSMSSentCountDATA } = useQuery({
    queryKey: ["GetLackOfWalletDeviceRequestSMSSentCount"],
    queryFn: async () => {
      const response = await GetLackOfWalletDeviceRequestSMSSentCount(
        userProducerCenter?.producerCenterId
      );
      if (response?.data.isSuccess) {
        if (response.data.data?.count > 0) {
          setRequestSMSCount(response.data.data?.count);
        }
      } else {
      }

      return response;
    },
    refetchInterval: 600000,
  });

  const updateProducerCenterWallet = () => {

  }

  return (
    <div className="app-navbar flex-shrink-0">
      <VisitedChecker
        localStorageKey="first-login-user"
        setVisited={setFirstLoginStatus}
      />
      {/* tickets begin*/}
      <RegisterProducerCenterModal
        showModal={displayRegisterProducerCenterModal}
        hideModal={hideRegisterProducerCenterModal}
        showStep1={displayRegisterProducerCenterStep1}
      />

      <SoftwareDownload
        showModal={showDownloadLink}
        hideModal={() => setShowDownloadLinkValue(false)}
      />
      <div
        className={clsx(
          "app-navbar-item app-navbar-item rounded m-3",
          itemClass
        )}
        style={{ height: "55px", position: "relative" }}
      >
        {requestSMSCount > 0 && (
          <span className="notificationsBadge">
            1
          </span>
        )}
        <div
          className={clsx("cursor-pointer symbol", userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-start"
        >
          <span className="HeaderMenuTrigger__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-bell"
              viewBox="0 0 16 16"
            >
              <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
            </svg>
          </span>
        </div>
        <HeaderNotificationsMenu requestSMSCount={requestSMSCount} />
      </div>

      <div
        className={clsx("app-navbar-item rounded m-3", itemClass)}
        style={{ height: "55px" }}
      >
        <div
          className={clsx("cursor-pointer symbol", userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-start"
        >
          <Link to={`ticket/list`}>
            <span className="HeaderMenuTrigger__icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                style={{ fill: "black" }}
                className="bi bi-headset"
                viewBox="0 0 16 16"
              >
                <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5" />
              </svg>
            </span>
          </Link>
        </div>
      </div>

      {/* tickets end*/}
      <div
        className={clsx(
          "app-navbar-item  app-navbar-item rounded m-3",
          itemClass
        )}
        style={{ height: "55px" }}
         onClick={() => UpdateProducerCenterWalletPrice()}
      >
        <div
          className={clsx("cursor-pointer symbol", userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-start"
        >
          <span className="HeaderMenuTrigger__icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.5 4V20"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19 9.5H20.5C21.0523 9.5 21.5 9.94772 21.5 10.5V13.5C21.5 14.0523 21.0523 14.5 20.5 14.5H19C17.6193 14.5 16.5 13.3807 16.5 12V12C16.5 10.6193 17.6193 9.5 19 9.5V9.5Z"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M20.5 14.5V17.5C20.5 18.8807 19.3807 20 18 20H6C4.61929 20 3.5 18.8807 3.5 17.5V6.5C3.5 5.11929 4.61929 4 6 4H18C19.3807 4 20.5 5.11929 20.5 6.5V9.5"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </span>
          <label style={{ direction: "ltr", marginRight: "10px" }}>
            {userProducerCenter?.walletPrice?.toLocaleString()}
          </label>
        </div>
        <HeaderPaymentMenu />
      </div>

      <div
        className={clsx("app-navbar-item rounded m-3", itemClass)}
        style={{ height: "55px" }}
      >
        <div
          className={clsx("cursor-pointer symbol", userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-start"
        >
          <span className="HeaderMenuTrigger__icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.43518 15.4352C5.3541 14.5162 6.60044 14 7.9 14H15.9C17.1996 14 18.4459 14.5162 19.3648 15.4352C20.2838 16.3541 20.8 17.6004 20.8 18.9V20.9C20.8 21.3971 20.3971 21.8 19.9 21.8C19.4029 21.8 19 21.3971 19 20.9V18.9C19 18.0778 18.6734 17.2893 18.092 16.708C17.5107 16.1266 16.7222 15.8 15.9 15.8H7.9C7.07783 15.8 6.28933 16.1266 5.70797 16.708C5.12661 17.2893 4.8 18.0778 4.8 18.9V20.9C4.8 21.3971 4.39706 21.8 3.9 21.8C3.40294 21.8 3 21.3971 3 20.9V18.9C3 17.6004 3.51625 16.3541 4.43518 15.4352Z"
                fill="currentColor"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9 3.8C10.1879 3.8 8.8 5.18792 8.8 6.9C8.8 8.61208 10.1879 10 11.9 10C13.6121 10 15 8.61208 15 6.9C15 5.18792 13.6121 3.8 11.9 3.8ZM7 6.9C7 4.1938 9.1938 2 11.9 2C14.6062 2 16.8 4.1938 16.8 6.9C16.8 9.6062 14.6062 11.8 11.9 11.8C9.1938 11.8 7 9.6062 7 6.9Z"
                fill="currentColor"
              ></path>
            </svg>
          </span>
          <label style={{ direction: "ltr", marginRight: "10px" }}>
            {currentUser?.phoneNumber}
          </label>
        </div>
        <HeaderUserMenu />
      </div>

      {/* {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' />
          </div>
        </div>
      )} */}
    </div>
  );
};

export { Navbar };
